import z from 'zod';
import {
    CommanderFormProps,
    SchemaFormDefinition,
    SchemaFormFields,
    useHandledDialogFormControls,
} from '@mews-commander/form';
import { createZodFormResolver, getDefaults } from '@mews/framework';

import { SelectAttachmentField } from './SelectAttachmentField';

const selectAttachmentFromLibrarySchema = (previouslySelected: string[]) =>
    z.object({
        selectedAttachments: z.array(z.string().uuid()).default(previouslySelected),
    });

export type SelectedAttachmentValues = z.infer<ReturnType<typeof selectAttachmentFromLibrarySchema>>;

const selectAttachmentFromLibraryFormDefinition = (
    previouslySelected: string[]
): SchemaFormDefinition<ReturnType<typeof selectAttachmentFromLibrarySchema>> => ({
    fields: {
        selectedAttachments: {
            render: (props) => <SelectAttachmentField previouslySelected={previouslySelected} {...props} />,
        },
    },
});

export const SelectAttachmentForm = ({
    handleAddAttachment,
    previouslySelected = [],
    ...props
}: CommanderFormProps & { previouslySelected?: string[]; handleAddAttachment: (ids: string[]) => void }) => {
    const schema = selectAttachmentFromLibrarySchema(previouslySelected);
    const { renderFormContent } = useHandledDialogFormControls<SelectedAttachmentValues>({
        ...props,
        defaultValues: getDefaults(schema),
        resolver: createZodFormResolver(schema),
        onSubmit: ({ selectedAttachments }) => {
            handleAddAttachment(selectedAttachments);
        },
    });

    return renderFormContent(
        <SchemaFormFields
            schema={schema}
            formDefinition={selectAttachmentFromLibraryFormDefinition(previouslySelected)}
        />
    );
};
